import './App.css';
import Allroutes from './component/Allroutes';

function App() {
  return (
  
      <div  style={{backgroundColor:"#f3f1ed"}}>
        <Allroutes/>
      </div>
  
  );
}

export default App;
